import { get } from 'lodash';
import { SET_IS_LOADING } from './is-loading-actions';
import { FETCH_POST_REQUEST, FETCH_POST_SUCCESS, FETCH_POST_FAILURE } from '../../actions/fetch-post';
import {
  FETCH_LAST_FEATURED_POST_REQUEST,
  FETCH_LAST_FEATURED_POST_SUCCESS,
  FETCH_LAST_FEATURED_POST_FAILURE,
} from '../../actions/fetch-last-featured-post';
import {
  FETCH_CATEGORY_POSTS_REQUEST,
  FETCH_CATEGORY_POSTS_SUCCESS,
  FETCH_CATEGORY_POSTS_FAILURE,
} from '../../actions/fetch-category-posts';
import {
  FETCH_TAG_POSTS_REQUEST,
  FETCH_TAG_POSTS_SUCCESS,
  FETCH_TAG_POSTS_FAILURE,
} from '../../actions/fetch-tag-posts';
import {
  FETCH_USER_POSTS_REQUEST,
  FETCH_USER_POSTS_SUCCESS,
  FETCH_USER_POSTS_FAILURE,
} from '../../actions/fetch-posts-by-user';
import {
  FETCH_USER_COMMENTS_REQUEST,
  FETCH_USER_COMMENTS_SUCCESS,
  FETCH_USER_COMMENTS_FAILURE,
} from '../comments/fetch-comments-by-user';
import {
  FETCH_FEED_POSTS_REQUEST,
  FETCH_FEED_POSTS_SUCCESS,
  FETCH_FEED_POSTS_FAILURE,
} from '../../actions/fetch-feed-posts';
import { FETCH_POSTS_REQUEST, FETCH_POSTS_SUCCESS, FETCH_POSTS_FAILURE } from '../../actions/fetch-posts';
import {
  FETCH_RECENT_POSTS_REQUEST,
  FETCH_RECENT_POSTS_SUCCESS,
  FETCH_RECENT_POSTS_FAILURE,
} from '../../../post-page/actions/fetch-recent-posts';
import { FETCH_ARCHIVE_REQUEST, FETCH_ARCHIVE_SUCCESS, FETCH_ARCHIVE_FAILURE } from '../../actions/fetch-archive';
import { FETCH_COMMENTS_REQUEST, FETCH_COMMENTS_SUCCESS, FETCH_COMMENTS_FAILURE } from '../comments/fetch-comments';
import { FETCH_MEMBERS_REQUEST, FETCH_MEMBERS_SUCCESS, FETCH_MEMBERS_FAILURE } from '../../actions/fetch-members';
import { FETCH_SEARCH_SUCCESS, FETCH_SEARCH_FAILURE } from '../../../search/actions/fetch-search';
import { SAVE_POST_DRAFT_REQUEST } from '../../actions/save-post-draft';
import { POST_STATUS } from '@wix/communities-blog-universal/dist/src/constants/post';
import { SEARCH_CLEAR_RESULTS } from '../../../search/actions/search';

// eslint-disable-next-line complexity
export default function isLoading(state = {}, action) {
  switch (action.type) {
    case SET_IS_LOADING:
      return setIsLoading(state, action.payload);

    case FETCH_POST_REQUEST: {
      return setIsLoading(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoading: true,
      });
    }
    case FETCH_POST_SUCCESS:
    case FETCH_POST_FAILURE:
      return setIsLoading(state, {
        entity: 'post',
        id: action.payload.postSlug,
        isLoading: false,
      });

    case FETCH_LAST_FEATURED_POST_REQUEST: {
      return setIsLoading(state, {
        entity: 'last-featured-post',
        isLoading: true,
      });
    }
    case FETCH_LAST_FEATURED_POST_SUCCESS:
    case FETCH_LAST_FEATURED_POST_FAILURE:
      return setIsLoading(state, {
        entity: 'last-featured-post',
        isLoading: false,
      });

    case FETCH_FEED_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'feed-posts',
        isLoading: true,
      });
    }
    case FETCH_FEED_POSTS_SUCCESS:
    case FETCH_FEED_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'feed-posts',
        isLoading: false,
      });

    case FETCH_POSTS_REQUEST:
      return setIsLoading(state, {
        entity: 'posts',
        isLoading: true,
      });

    case FETCH_POSTS_SUCCESS:
    case FETCH_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'posts',
        isLoading: false,
      });

    case FETCH_RECENT_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'recent-posts',
        id: action.payload.postId,
        isLoading: true,
      });
    }

    case FETCH_RECENT_POSTS_SUCCESS:
    case FETCH_RECENT_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'recent-posts',
        id: action.meta.postId,
        isLoading: false,
      });

    case FETCH_USER_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: get(action, 'payload.status') === POST_STATUS.unpublished ? 'profile-drafts' : 'profile-posts',
        isLoading: true,
      });
    }
    case FETCH_USER_POSTS_SUCCESS:
      return setIsLoading(state, {
        entity: get(action, 'meta.status') === POST_STATUS.unpublished ? 'profile-drafts' : 'profile-posts',
        isLoading: false,
      });

    case FETCH_USER_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: get(action, 'payload.status') === POST_STATUS.unpublished ? 'profile-drafts' : 'profile-posts',
        isLoading: false,
      });

    case FETCH_USER_COMMENTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'profile-comments',
        isLoading: true,
      });
    }
    case FETCH_USER_COMMENTS_SUCCESS:
    case FETCH_USER_COMMENTS_FAILURE:
      return setIsLoading(state, {
        entity: 'profile-comments',
        isLoading: false,
      });

    case FETCH_CATEGORY_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'category',
        id: get(action, 'payload.categoryId'),
        isLoading: true,
      });
    }
    case FETCH_CATEGORY_POSTS_SUCCESS:
      return setIsLoading(state, {
        entity: 'category',
        id: get(action, 'meta.categoryId'),
        isLoading: false,
      });

    case FETCH_CATEGORY_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'category',
        id: get(action, 'payload.categoryId'),
        isLoading: false,
      });

    case FETCH_TAG_POSTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'tag',
        id: get(action, 'payload.tagId'),
        isLoading: true,
      });
    }
    case FETCH_TAG_POSTS_SUCCESS:
      return setIsLoading(state, {
        entity: 'tag',
        id: get(action, 'meta.tagId'),
        isLoading: false,
      });
    case FETCH_TAG_POSTS_FAILURE:
      return setIsLoading(state, {
        entity: 'tag',
        id: get(action, 'payload.tagId'),
        isLoading: false,
      });

    case FETCH_COMMENTS_REQUEST: {
      return setIsLoading(state, {
        entity: 'comments',
        id: action.payload.postId,
        isLoading: true,
      });
    }
    case FETCH_COMMENTS_SUCCESS:
    case FETCH_COMMENTS_FAILURE:
      return setIsLoading(state, {
        entity: 'comments',
        id: action.payload.postId,
        isLoading: false,
      });

    case FETCH_MEMBERS_REQUEST: {
      return setIsLoading(state, {
        entity: 'members',
        isLoading: true,
      });
    }
    case FETCH_MEMBERS_SUCCESS:
    case FETCH_MEMBERS_FAILURE:
      return setIsLoading(state, {
        entity: 'members',
        isLoading: false,
      });

    case FETCH_SEARCH_SUCCESS:
    case FETCH_SEARCH_FAILURE:
      return setIsLoading(state, {
        entity: 'search',
        isLoading: false,
      });

    case SAVE_POST_DRAFT_REQUEST:
      return setIsLoading(state, {
        entity: 'postDraft',
        isLoading: true,
        id: get(action, 'payload.draftKey', null),
      });

    case FETCH_ARCHIVE_REQUEST: {
      return setIsLoading(state, {
        entity: 'archive',
        isLoading: true,
      });
    }
    case FETCH_ARCHIVE_SUCCESS:
    case FETCH_ARCHIVE_FAILURE:
      return setIsLoading(state, {
        entity: 'archive',
        isLoading: false,
      });

    default:
      return state;
  }
}

function setIsLoading(state, { entity, id = '', isLoading }) {
  const entityState = id
    ? {
        ...state[entity],
        [id]: isLoading,
      }
    : isLoading;

  return {
    ...state,
    [entity]: entityState,
  };
}
